import { render, staticRenderFns } from "./MainPage.vue?vue&type=template&id=6d64ad48&scoped=true&"
import script from "./MainPage.vue?vue&type=script&lang=ts&"
export * from "./MainPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d64ad48",
  null
  
)

export default component.exports